<template>
  <div class="sizes-selector">
    <div class="sizes-selector__title">
      <div class="wrapp-left">
        <div class="size-title">
          <span>{{$t('size')}}</span>
        </div>
        <div class="separator mx-3"></div>
        <div class="size-fitting">
          <span>{{ fittingLabel || 'Regular' }}</span>
        </div>
      </div>
      <div class="size-guide" v-if="hasSizeChart">
        <a href="#" class="bcm-link bcm-link-primary" @click.prevent="toggleSizeGuide(true)">{{ $t('size-guide') }}</a>
      </div>
    </div>
    <div class="qty-available mt-2 mb-3" v-if="selected && selected.quantity">
      <span>{{$t('quantity-available')}} {{ selected.quantity }}</span>
    </div>
    <div class="sizes-selector__select wrapp-size-select">
      <b-spinner label="Spinning" v-if="loadVariants"></b-spinner>
      <ul class="size-choice nav" v-else>
        <li v-for="(opt, index) in optionsByFilter" :key="index"
        class="single-choice"
        :class="calcClassName(opt)"
        @mouseover="mouseover(opt.value)"
        @mouseleave="mouseleave()"
        @click.prevent="change(opt)">
          <span class="option-label">{{opt.label}}</span>
          <size-selector-extra-label
          class="extra-label"
          :onlyOneLeft="opt.quantity === 1"
          :outOfStock="!opt.in_stock"
          :isPreOrder="opt.is_preorder"
          ></size-selector-extra-label>
        </li>
      </ul>
      <p class="errors-message is-invalid" v-t="'size-select-error'" v-show="sizeError"></p>
    </div>
    <ModalSizeGuide v-model="modalSizeGuide" :product="product" @close="toggleSizeGuide(false)" />
  </div>
</template>

<script>
import { EventBus } from '@/helpers'
import { getVariantByFilter, getConfigurableOptMap } from 'theme/helpers'
import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import Config from '@/config'
import ModalSizeGuide from '../../Modal/SizeGuide'
import SizeSelectorExtraLabel from './SizeSelectorExtraLabel'

export default {
  props: {
    product: {
      type: Object,
      required: false,
      default: () => ({})
    },
    options: {
      type: Array,
      required: true
    },
    parentAttribute: {
      type: String,
      required: true
    },
    filterActive: {
      type: Object,
      required: true
    },
    defaultSelected: {
      type: String | Number,
      required: false,
      default: null
    },
    filterCode: {
      type: String,
      default: 'size'
    }
  },
  data () {
    return {
      sizeError: false,
      hoverChoice: null,
      selected: null,
      sizeCountries: Config.Theme.sizeCountries,
      modalSizeGuide: false
    }
  },
  computed: {
    loadVariants () {
      return this.$store.state.product.loadConfigurable
    },
    fittingLabel () {
      const attributesLabel = this.$store.state.product.current.attributesLabel
      return attributesLabel && attributesLabel.fitting_filter ? attributesLabel.fitting_filter.value : ''
    },
    optionsByFilter () {
      let filters = []
      if (this.product) {
        filters = getVariantByFilter(this.filterCode, this.filterActive, this.product.variants, this.product.configurable_options)
      } else {
        filters = this.$store.getters['product/getVariantByFilter'](this.filterCode, this.filterActive)
      }

      return filters && filters.length ? sortBy(filters, ['value']) : []
    },
    selectableOutOfStock () {
      return this.$store.state.product.selSizeProductOutOfStock
    },
    activeCountry () {
      return this.$store.getters['ui/getCurrentCountry']
    },
    hasSizeChart () {
      return this.product.hasOwnProperty('sizechart') ? this.product.sizechart.ok : false
    }
  },
  methods: {
    selectableOption (option) {
      if (!this.selectableOutOfStock) {
        return option.in_stock
      }
      return true
    },
    calcClassName (opt) {
      let className = {
        'active': this.selected && this.selected.value === opt.value,
        'out-of-stock': !opt.in_stock,
        'unselectableOptions': !this.selectableOption(opt)
      }
      return className
    },
    showError (payload) {
      this.sizeError = payload
    },
    listenerEventChange (payload) {
      let map = {}
      if (this.product) {
        map = getConfigurableOptMap(this.product.configurable_options)
      } else {
        map = this.$store.getters['product/getConfigurableOptMap']
      }
      if (map[payload.type] !== this.filterCode) {
        this.$nextTick(function () {
          // try to find on new option with old value selected
          if (this.selected && this.selected.value) {
            let matchArr = find(this.optionsByFilter, ['value', this.selected.value])
            this.selected = matchArr
            if (matchArr) {
              this.change(matchArr)
            }
          }
        })
      }
    },
    mouseover (optID) {
      this.hoverChoice = optID
    },
    mouseleave () {
      this.hoverChoice = null
    },
    change (newValues) {
      this.selected = newValues
      this.showError(false)
      this.$emit('filterSelected', this.getFilterCompose(newValues))
    },
    getFilterCompose (newValues) {
      return { type: this.parentAttribute, value: newValues.value, isNotificable: !newValues.in_stock }
    },
    toggleSizeGuide (data) {
      this.modalSizeGuide = data
    },
    checkDefaultValue (value = this.defaultSelected) {
      this.selected = { value: value }
      return this.listenerEventChange({ type: this.filterCode })
    }
  },
  watch: {
    defaultSelected (newValue, old) {
      if (newValue) {
        this.$nextTick(() => {
          this.checkDefaultValue(newValue)
        })
      }
    }
  },
  mounted () {
    EventBus.$on('product:filterChange', this.listenerEventChange)
    EventBus.$on('cart:sizeError', this.showError)
    this.checkDefaultValue()
  },
  destroyed () {
    EventBus.$off('cart:sizeError', this.showError)
    EventBus.$off('product:filterChange', this.listenerEventChange)
  },
  components: {
    ModalSizeGuide,
    SizeSelectorExtraLabel
  }
}
</script>
